<template>
  <Tooltip
    v-model:open="open"
    :side="props.side"
    :disable-closing-trigger="true"
    content-class="p-0"
  >
    <Button
      type="button"
      variant="fill"
      shape="circle"
      size="icon-sm"
      color="normal"
      class="cursor-default active:bg-key active:text-text-glass-default"
      :aria-label="props.content"
    >
      <Icon icon="Function-Wireframe-Warning" />
    </Button>
    <template #content>
      <div
        class="text-s-medium text-white-black p-1 bg-floating-tooltip-container rounded-m whitespace-nowrap"
      >
        {{ props.content }}
      </div>
    </template>
  </Tooltip>
</template>

<script setup lang="ts">
  import { Button, Icon, Tooltip } from '@rapoo/element'

  interface Props {
    content: string
    side?: 'left' | 'right' | 'top' | 'bottom'
  }

  const props = withDefaults(defineProps<Props>(), {
    side: 'top',
  })

  /**
   * 将 Tooltip 的打开状态直接代理给父组件的 `v-model:open`。
   * defineModel 会同时声明 `open` prop 和 `update:open` emit。
   */
  const open = defineModel<boolean>('open', { default: false })
</script>
